module.exports = __webpack_public_path__ + "static/media/Macroeconomics.6f027f86.png";